<template>
  <transition name="vs-sidebar-animate">
    <div
      v-show="staticPosition || active"
      v-bind="$attrs"
      ref="sidebarBackground"
      class="vs-content-sidebar"
    >
      <div
        v-if="!hiddenBackground"
        class="vs-sidebar--background"
      />
      <div
        ref="sidebarContainer"
        class="vs-sidebar"
        :class="[
          `vs-sidebar-${color}`,
          {
            'vs-sidebar-parent': parent !== 'body',
            'vs-sidebar-staticPosition': staticPosition,
            'vs-sidebar-position-right': positionRight,
            'vs-sidebar-reduce': reduce,
            'vs-sidebar-reduceNotRebound': reduceNotRebound,
            'vs-sidebar-reduceNotHoverExpand': reduceNotHoverExpand,
          },
        ]"
      >
        <header v-if="$slots.header" class="vs-sidebar--header">
          <slot name="header" />
        </header>
        <div class="vs-sidebar--items">
          <slot />
        </div>
        <div v-if="spacer" class="vs-spacer" />
        <footer v-if="$slots.footer" class="vs-sidebar--footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VsSidebar",
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    defaultIndex: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: "primary",
    },
    parent: {
      type: [String, Object],
      default: null,
    },
    spacer: {
      type: Boolean,
      default: false,
    },
    staticPosition: {
      type: Boolean,
      default: false,
    },
    positionRight: {
      type: Boolean,
      default: false,
    },
    clickNotClose: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Boolean,
      default: false,
    },
    reduceNotRebound: {
      type: Boolean,
      default: false,
    },
    reduceNotHoverExpand: {
      type: Boolean,
      default: false,
    },
    hiddenBackground: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "input"],
  data() {
    return {
      currentIndex: this.defaultIndex,
      clickTarget: null,
      clickTimer: null,
    };
  },
  computed: {
    active() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },
  watch: {
    active() {
      this.syncOutsideClick();
    },
    parent() {
      this.moveToParent();
      this.syncOutsideClick();
    },
    clickNotClose() {
      this.syncOutsideClick();
    },
  },
  mounted() {
    this.moveToParent();
    this.syncOutsideClick();
  },
  beforeUnmount() {
    this.removeOutsideClick();
    clearTimeout(this.clickTimer);
  },
  methods: {
    getActive() {
      return this.currentIndex;
    },
    setIndexActive(index) {
      this.currentIndex = index;
    },
    resolveParent() {
      if (!this.parent || this.parent === "body") return null;
      return typeof this.parent === "string"
        ? document.querySelector(this.parent)
        : this.parent;
    },
    moveToParent() {
      const parent = this.resolveParent();
      const element = this.$refs.sidebarBackground;
      if (parent && element && element.parentNode !== parent) {
        parent.insertBefore(element, parent.firstChild);
      }
    },
    getClickTarget() {
      return this.resolveParent() || window;
    },
    syncOutsideClick() {
      this.removeOutsideClick();
      if (!this.active || this.clickNotClose) return;

      this.clickTimer = setTimeout(() => {
        this.clickTarget = this.getClickTarget();
        this.clickTarget.addEventListener("click", this.closeSidebar);
      }, 300);
    },
    removeOutsideClick() {
      clearTimeout(this.clickTimer);
      this.clickTimer = null;
      if (this.clickTarget) {
        this.clickTarget.removeEventListener("click", this.closeSidebar);
        this.clickTarget = null;
      }
    },
    closeSidebar(event) {
      const container = this.$refs.sidebarContainer;
      if (container && container.contains(event.target)) return;
      this.setActive(false);
      this.removeOutsideClick();
    },
    setActive(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
  },
};
</script>
